import React from 'react';
import { useParams, Navigate } from 'react-router-dom';

const RedirectToPartnerId = () => {
  const { partnerId } = useParams();
  return <Navigate to={`/${partnerId}`} replace />;
};

export default RedirectToPartnerId;
